import { combineReducers} from 'redux';

import patientReducer from './patientReducer';
import selectedPatientReducer from './selectedPatientReducer';

//Analytic
import { warningReducer, dueReducer } from './analyticReducer';

//General Panel
import { vaccinationReducer, selectedVaccineReducer}  from './vaccinationReducer';
import { medicationReducer, selectedMedicationReducer } from './medicationReducer';
import { todoReducer, selectedTodoReducer } from './todoReducer';
import { historyReducer, selectedHistoryReducer } from './historyReducer';
import { otherdetailReducer, selectedOtherDetailReducer } from './otherdetailReducer';
import { preventiveReducer, selectedPreventiveReducer } from './preventiveReducer';
import { reminderReducer, selectedReminderReducer } from './reminderReducer';
import { reactionReducer, selectedReactionReducer } from './reactionReducer';
import { requestpathReducer, selectedRequestPathReducer } from './requestpathReducer';
import { visitReducer, selectedVisitReducer } from './visitReducer';
import { prescriptionReducer, selectedPrescriptionReducer } from './prescriptionReducer';
import { familyhistoryReducer, selectedFamilyHistoryReducer } from './familyhistoryReducer';

//Chronic disease Library
import { diseaselibReducer, selectedDiseaseLibReducer } from './diseaselibReducer';
import { arrangelibReducer, selectedArrangeLibReducer } from './arrangelibReducer';
import { goallibReducer, selectedGoalLibReducer } from './goallibReducer';
import { educationlibReducer, selectedEducationLibReducer } from './educationlibReducer';
import { monitorlibReducer, selectedMonitorLibReducer } from './monitorlibReducer';
//Chronic disease cards
import { goalReducer, selectedGoalReducer } from './goalReducer';
import { problemReducer, selectedProblemReducer } from './problemReducer';
import { arrangeReducer, selectedArrangeReducer } from './arrangeReducer';
import { educationReducer, selectedEducationReducer } from './educationReducer';
import { monitorReducer, selectedMonitorReducer } from './monitorReducer';


//User Permission
import { userReducer, selectedUserReducer } from './userReducer';
import { permissionReducer, selectedPermissionReducer } from './permissionReducer';
import { authReducer, selectedAuthReducer} from './authReducer';

//Health Assessment
import { ha_detailReducer, selectedHA_DetailReducer } from './ha_detailReducer';
import { ha_examReducer, selectedHA_ExamReducer } from './ha_examReducer';

//AOD
import { aod_historyReducer, selectedAOD_HistoryReducer } from './aod_historyReducer';
import { aod_legalReducer, selectedAOD_LegalReducer } from './aod_legalReducer';
import { aod_planReducer, selectedAOD_PlanReducer } from './aod_planReducer';
import { aod_substanceReducer, selectedAOD_SubstanceReducer } from './aod_substanceReducer';

//Pain
import { pain_examinationReducer, selectedPain_ExaminationReducer } from './pain_examinationReducer';
import { pain_historyReducer, selectedPain_HistoryReducer } from './pain_historyReducer';
import { pain_psychosocialReducer, selectedPain_PsychoSocialReducer } from './pain_psychosocialReducer';
import { pain_reviewReducer, selectedPain_ReviewReducer } from './pain_reviewReducer';
import { pain_treatmentReducer, selectedPain_TreatmentReducer } from './pain_treatmentReducer';

//Mental Health
import { mh_actionReducer, selectedMH_ActionReducer } from './mh_actionReducer';
import { mh_formulateReducer, selectedMH_FormulateReducer } from './mh_formulateReducer';
import { mh_profileReducer, selectedMH_ProfileReducer } from './mh_profileReducer';
import { mh_providerReducer, selectedMH_ProviderReducer } from './mh_providerReducer';
import { mh_reviewReducer, selectedMH_ReviewReducer } from './mh_reviewReducer';
import { mh_safetyReducer, selectedMH_SafetyReducer } from './mh_safetyReducer';

//Image
import { image_episodeReducer, selectedImage_EpisodeReducer } from './image_episodeReducer';
import { image_photoReducer, selectedImage_PhotoReducer } from './image_photoReducer';
//Observation
import { observationReducer, selectedObservationReducer } from './observationReducer';
//Pathology
import { pathologyReducer, selectedPathologyReducer} from './pathologyReducer';
//Home
import { home_bpReducer, selectedHome_BPReducer } from './home_bpReducer';
import { home_weightReducer,selectedHome_WeightReducer } from './home_weightReducer';
import { home_glucoseReducer, selectedHome_GlucoseReducer } from './home_glucoseReducer';

//Flag
import { flagReducer, selectedFlagReducer } from './flagReducer';

//Photo
import { photo_externalReducer, selectedPhoto_ExternalReducer } from './photo_externalReducer';
import { photo_macroReducer, selectedPhoto_MacroReducer } from './photo_macroReducer';
import { photo_dermoscopyReducer, selectedPhoto_DermoscopyReducer } from './photo_dermoscopyReducer';
import { photo_displayReducer, showPhoto_DisplayReducer } from './photo_displayReducer';
import { show_dermoscopyReducer, selectedShow_DermoscopyReducer } from './show_dermoscopyReducer';


export default combineReducers({
  
    // patient
    patients : patientReducer,
    selectedPatient : selectedPatientReducer,

    /////// ANalytic
    warning : warningReducer,
    due : dueReducer,

    /////////////////// GENERAL PANEL REDUCER
    //
    vaccinations: vaccinationReducer,
    selectedVaccine: selectedVaccineReducer,
    //
    medications : medicationReducer,
    selectedMedication : selectedMedicationReducer,
    //
    todos: todoReducer,
    selectedTodo : selectedTodoReducer,
    //
    histories : historyReducer,
    selectedHistory : selectedHistoryReducer,
    //
    otherdetails: otherdetailReducer,
    selectedOtherDetail : selectedOtherDetailReducer,
    //
    preventives: preventiveReducer,
    selectedPreventive : selectedPreventiveReducer,
    //
    ha_details: ha_detailReducer,
    selectedHA_Detail : selectedHA_DetailReducer,
    //
    ha_exams: ha_examReducer,
    selectedHA_Exam : selectedHA_ExamReducer,
    //
    reminders : reminderReducer,
    selectedReminder : selectedReminderReducer,
    //
    reactions : reactionReducer,
    selectedReaction : selectedReactionReducer,
    //
    requestpaths : requestpathReducer,
    selectedRequestPath : selectedRequestPathReducer,
    //
    visits : visitReducer,
    selectedVisit : selectedVisitReducer,
    //
    prescriptions : prescriptionReducer,
    selectedPrescription : selectedPrescriptionReducer,
    //
    familyhistories : familyhistoryReducer,
    selectedFamilyHistory : selectedFamilyHistoryReducer,
   
    /////// CHRONIC DISEASE REDUCER
    //
    diseaselibs : diseaselibReducer,
    selectedDiseaseLib : selectedDiseaseLibReducer,
    //
    arrangelibs : arrangelibReducer,
    selectedArrangeLib : selectedArrangeLibReducer,
    //
    goallibs : goallibReducer,
    selectedGoalLib : selectedGoalLibReducer,
    //
    educationlibs : educationlibReducer,
    selectedEducationLib : selectedEducationLibReducer,
    //
    monitorlibs : monitorlibReducer,
    selectedMonitorLib : selectedMonitorLibReducer,
    //
    goals: goalReducer,
    selectedGoal : selectedGoalReducer,
    //
    problems: problemReducer,
    selectedProblem : selectedProblemReducer,
    //
    arranges: arrangeReducer,
    selectedArrange : selectedArrangeReducer,
    //
    educations: educationReducer,
    selectedEducation : selectedEducationReducer,
    //
    monitors: monitorReducer,
    selectedMonitor : selectedMonitorReducer,

    ///// PERMISSION REDUCER
    //
    users: userReducer,
    selectedUser : selectedUserReducer,
    //
    permissions: permissionReducer,
    selectedPermission : selectedPermissionReducer,
    //
    auth: authReducer,
    selectedAuth : selectedAuthReducer,

    /////////// - AOD Reducer
    aod_historys: aod_historyReducer,
    selectedAOD_History : selectedAOD_HistoryReducer,
    //
    aod_legals: aod_legalReducer,
    selectedAOD_Legal : selectedAOD_LegalReducer,
    //
    aod_plans: aod_planReducer,
    selectedAOD_Plan : selectedAOD_PlanReducer,
    //
    aod_substances: aod_substanceReducer,
    selectedAOD_Substance : selectedAOD_SubstanceReducer,

    ////////////// Pain Reducers
    pain_examinations: pain_examinationReducer,
    selectedPain_Examination : selectedPain_ExaminationReducer,
    //
    pain_historys: pain_historyReducer,
    selectedPain_History : selectedPain_HistoryReducer,
    //
    pain_psychosocials: pain_psychosocialReducer,
    selectedPain_Psychosocial : selectedPain_PsychoSocialReducer,
    //
    pain_reviews: pain_reviewReducer,
    selectedPain_Review : selectedPain_ReviewReducer,
    //
    pain_treatments: pain_treatmentReducer,
    selectedPain_Treatment : selectedPain_TreatmentReducer,

    ///////////// Mental Health Reducers
    mh_actions: mh_actionReducer,
    selectedMH_Action : selectedMH_ActionReducer,
    //
    mh_formulates: mh_formulateReducer,
    selectedMH_Formulate : selectedMH_FormulateReducer,
    //
    mh_profiles: mh_profileReducer,
    selectedMH_Profile : selectedMH_ProfileReducer,
    //
    mh_providers: mh_providerReducer,
    selectedMH_Provider : selectedMH_ProviderReducer,
    //
    mh_reviews: mh_reviewReducer,
    selectedMH_Review : selectedMH_ReviewReducer,
    //
    mh_safetys: mh_safetyReducer,
    selectedMH_Safety : selectedMH_SafetyReducer,
    ///////////
    image_episodes: image_episodeReducer,
    selectedImage_Episode : selectedImage_EpisodeReducer,
    //
    image_photos: image_photoReducer,
    selectedImage_Photo : selectedImage_PhotoReducer,
    //
    observations: observationReducer,
    selectedObservation : selectedObservationReducer,
    //
    pathologys: pathologyReducer,
    selectedPathology : selectedPathologyReducer,
    ////////
    home_bps : home_bpReducer,
    selectedHome_BP : selectedHome_BPReducer,
    //
    home_weights : home_weightReducer,
    selectedHome_Weight : selectedHome_WeightReducer,
    //
    home_glucoses : home_glucoseReducer,
    selectedHome_Glucose : selectedHome_GlucoseReducer,
    //
    flags: flagReducer,
    selectedFlag : selectedFlagReducer,
    //////
    photo_externals: photo_externalReducer,
    selectedPhoto_External : selectedPhoto_ExternalReducer,
    //
    photo_macros: photo_macroReducer,
    selectedPhoto_Macro : selectedPhoto_MacroReducer,
    //
    photo_dermoscopys: photo_dermoscopyReducer,
    selectedPhoto_Dermoscopy : selectedPhoto_DermoscopyReducer,
    //
    photo_displays: photo_displayReducer,
    showPhoto_Display : showPhoto_DisplayReducer,
    //
    show_dermoscopy : show_dermoscopyReducer,
    selectedShow_Dermoscopy : selectedShow_DermoscopyReducer
});